import React, { useEffect, useState } from "react";
import TableSkeleton from "../../../../../common/TableSkeleton";
import DashboardButton from "../DashboardButton";

const LatestOrders = () => {

    const statusColors = {
        completed: {
            color: "var(--color-ec-completedText)",
            background: "var(--color-ec-completedBg)",
            border: "1px solid var(--color-ec-completedBorder)",
        },
        cancelled: {
            color: "var(--color-ec-cancelledText)",
            background: "var(--color-ec-cancelledBg)",
            border: "1px solid var(--color-ec-cancelledBorder)",
        },
        refunded: {
            color: "var(--color-ec-refundedText)",
            background: "var(--color-ec-refundedBg)",
            border: "1px solid var(--color-ec-refundedBorder)",
        },
        pending: {
            color: "var(--color-ec-pendingText)",
            background: "var(--color-ec-pendingBg)",
            border: "1px solid var(--color-ec-pendingBorder)",
        },
        on_hold: {
            color: "var(--color-ec-onHoldText)",
            background: "var(--color-ec-onHoldBg)",
            border: "1px solid var(--color-ec-onHoldBorder)",
        },
        // failed: {
        //     color: "var(--color-ec-failedText)",
        //     background: "var(--color-ec-failedBg)",
        //     border: "1px solid var(--color-ec-failedBorder)",
        // },
        processing: {
            color: "var(--color-ec-processingText)",
            background: "var(--color-ec-processingBg)",
            border: "1px solid var(--color-ec-processingBorder)",
        },
    };


    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const url = `${EASYCOMMERCE.rest_base}/dashboard/recent_orders`;

        fetch(url,{
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setIsLoading(false);

                if (data.success) {
                    setOrders(data.data.orders);
                }
            });
    }, []);

    const customerIds = orders.map((order) => order.customer);
    const [customers, setCustomers] = useState([]);

    return (
        <>
            {isLoading ? (
                <TableSkeleton numberOfRows={5} SkeletonHeight={35} />
            ) : orders.length === 0 ? (
                <div className=" text-sm text-ec-body px-[30px] pb-[30px]">
                    No orders found.
                </div>
            ) : (
                <>
                    <div className="px-[30px]">
                         <table class="table-auto w-full">
                            <thead>
                                <tr className="bg-ec-table-bg">
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize rounded-tl-md rounded-bl-md text-ec-body">
                                        Order ID
                                    </th>
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize text-ec-body">
                                        Customer name
                                    </th>
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize text-ec-body">
                                        Amount
                                    </th>
                                    <th className="text-sm font-inter text-left font-medium p-3 capitalize text-ec-body">
                                        Status
                                    </th>
                                    <th className="p-3 rounded-tr-md rounded-br-md"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {orders.map(
                                    (item, index) =>
                                        index < 5 && (
                                            <>
                                                <tr
                                                    className={`${
                                                        index < 4
                                                            ? "border-b border-[#F8F8F8]"
                                                            : ""
                                                    } h-[70px]`}
                                                    key={index}
                                                >
                                                    <td className="px-3">
                                                        <span className="flex flex-col justify-start items-start">
                                                            <a
                                                                href={`#/orders/${item.id}`}
                                                                className="font-inter text-sm text-ec-body focus:shadow-none focus:outline-none"
                                                            >
                                                                #{item.id}
                                                            </a>
                                                            <span className="flex flex-col justify-start items-start text-ec-placeholder">
                                                                <span>
                                                                    {item.created_at ? item.created_at : "N/A"}
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>

                                                    <td className="px-3">
                                                        <span className="text-sm font-inter text-ec-body">
                                                            {item.customer_name}
                                                        </span>
                                                    </td>
                                                    <td className="px-3">
                                                        <span className="text-sm font-inter text-ec-body">
                                                            {EASYCOMMERCE.currency_symbol}{item.total}
                                                        </span>
                                                    </td>
                                                    <td className="px-3">
                                                        <span
                                                            className={`px-3 py-1 font-inter rounded-lg text-sm`}
                                                            style={{
                                                                color: statusColors[item.status]?.color,
                                                                background: statusColors[item.status]?.background,
                                                                border: statusColors[item.status]?.border,
                                                            }}
                                                        >
                                                            {item.status.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}
                                                        </span>
                                                    </td>

                                                    <td className="px-3 h-[70px] flex justify-end items-center">
                                                        <a
                                                            href={`#/orders/${item.id}`}
                                                            className="flex font-inter justify-center items-center gap-[6px] border-ec-primary rounded-lg border hover:bg-ec-primary px-3 py-1 ease-in-out duration-500 hover:ease-in-out hover:duration-500 
                                                            text-ec-primary hover:text-white text-sm font-medium active:bg-ec-primary active:text-white focus:bg-ec-accent focus:text-ec-primary focus:shadow-none focus:outline-none"
                                                        >
                                                            View
                                                            <svg 
                                                                width="7"
                                                                height="11"
                                                                viewBox="0 0 7 11"
                                                                fill="none"
                                                                className="fill-current"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M1.93359 1.15625L5.87109 5.3125C5.98047 5.4401 6.03516 5.58594 6.03516 5.75C6.03516 5.91406 5.98047 6.06901 5.87109 6.21484L1.93359 10.3711C1.64193 10.6263 1.34115 10.6263 1.03125 10.3711C0.757812 10.0794 0.748698 9.76953 1.00391 9.44141L4.50391 5.75L1.00391 2.03125C0.748698 1.72135 0.757812 1.42057 1.03125 1.12891C1.34115 0.873698 1.64193 0.882812 1.93359 1.15625Z"/>
                                                            </svg>

                                                        </a>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                )}
                            </tbody>
                        </table>
                    </div>
                   
                    <div className="px-8 pb-8">
                        <DashboardButton url={`admin.php?page=easycommerce#/orders`} />
                    </div>
                </>
            )}
        </>
    );
};

export default LatestOrders;
